<template>
	<div class="spouse-wrap">
    <span class="label">{{ title }}</span>
    <div class="input-wrap input-wrap--spouse">
  		<button 
        class="input input--spouse spouse__button"
  			@click="openPanel">
        <span>{{ setSpouseName }}</span>
  		</button>
      <Icon icon="link"></Icon>
    </div>
	</div>
</template>

<script>

/**
 * Modal JSFiddle
 * https://jsfiddle.net/yyx990803/mwLbw11k/?utm_source=website&utm_medium=embed&utm_campaign=mwLbw11k
 *
 * Repeater JSFiddle
 * https://jsfiddle.net/cr8vfgrz/10/
 */

import Icon  from './Icon.vue'

export default {

  /**
   * COMPONENTS
   * ----------
   * 
   * These are the components that can be used by this 
   * component
   */
  
  components: {
    Icon
  },  

  /**
   * METHODS
   * -------
   * 
   * These are the methods that are available to the 
   * component.
   */
   
  methods : {

    openPanel() {

      this.$parent.$data.subpanel.field = this.field;
      this.$parent.$data.subpanel.proto = this.proto;
      this.$parent.$data.subpanel.title = this.title;
      this.$parent.$data.subpanel.view  = 'spouseForm';      

      this.$parent.$data.subpanel.data  = this.$store.getters.getFieldData(this.$parent.$data.subpanel);
      this.$parent.$data.subpanel.save  = {
        id: JSON.parse( JSON.stringify( this.$parent.$data.subpanel.data )),
        spouse: JSON.parse( JSON.stringify( this.$store.getters.getClientSpouseData()))
      };

      this.$parent.$data.subpanel.state = 'active';

    },

  },


  /**
   * COMPUTED
   * --------
   * 
   * These functions are used to return computed values, which
   * can be bound to certain portions of the component.
   */  

  computed: {

    setSpouseName() {

      var name = 'Spouse Name',
          data = this.$store.getters.getFieldData({ field: this.field }),
          client = this.$store.getters.getClientName({ id: data });

      return client;

    },

  },

  props : [
  	'title',
  	'field',    
  ],

  data() {

    return {

    }

  }

}

</script>

<style lang="scss">

  .spouse-wrap {

    // border: 1px solid red;
    position: relative;
    margin: 0 0 .75rem;

    .icon {

      position: absolute;
      right: -1.5rem;
      top: 1em;

      width: 1rem;
      height: 1rem;

    }

    .icon__svg {

      fill: #444;
      stroke: #444;
    }

  }

  .input-wrap--spouse {

    width: calc(100% - 30px);

  }
  
</style>



// WEBPACK FOOTER //
// Spouse.vue?754eb5a0